// NPM
import React, { Component } from 'react';

import PercentageRankedList from './PercentageRankedList';
import TagRankedList from './TagRankedList';

class RankedLists extends Component {
  render() {
    const { recommendationsCount } = this.props;
    return (
      <div className="RankedLists">
        <PercentageRankedList
          heading="categories"
          schema="categories"
          totalCount={recommendationsCount}
        />
        <PercentageRankedList
          heading="schools"
          schema="universities"
          totalCount={recommendationsCount}
        />
        <TagRankedList heading="subcategories" schema="subcategories" />
        <TagRankedList heading="cities" schema="cities" />
      </div>
    );
  }
}

export default RankedLists;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/index.js